"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc998CompositionFormValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.erc998CompositionFormValidationSchema = (0, yup_1.object)().shape({
    parentId: yup_rules_1.dbIdValidationSchema,
    childId: yup_rules_1.dbIdValidationSchema,
    amount: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(1, "form.validations.rangeUnderflow"),
});
//# sourceMappingURL=validation.js.map